var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { "margin-left": "10px" },
      attrs: { id: "Screening-report" },
    },
    [
      _c(
        "Tabs",
        {
          attrs: { type: "card", value: _vm.activeName },
          on: { "on-click": _vm.handleClick },
        },
        _vm._l(_vm.reportTypes, function (item, index) {
          return _vm.reportTypes && _vm.reportTypes.length > 0
            ? _c(
                "TabPane",
                {
                  key: item.code,
                  style: { "max-height": _vm.maxHeight, "overflow-y": "auto" },
                  attrs: { label: item.name, name: item.code },
                },
                [
                  item.code === "phccloud"
                    ? _c("phccloudReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "tianHeChildrenEnrolment"
                    ? _c("tianHeChildrenEnrolmentReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "congHuaKindergarten"
                    ? _c("congHuaKindergartenReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "huangPuUniversity"
                    ? _c("huangPuUniversityReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "primaryEnrolment"
                    ? _c("primaryEnrolmentReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "middlePrimarySecondary"
                    ? _c("middlePrimarySecondaryReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "university"
                    ? _c("universityReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "generalInspection"
                    ? _c("generalInspectionReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "monthChildren"
                    ? _c("monthChildrenReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "ageChildren"
                    ? _c("ageChildrenReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "hearing"
                    ? _c("hearingReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "vision"
                    ? _c("visionReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "dentalCaries"
                    ? _c("dentalCariesReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "middleEar"
                    ? _c("middleEarReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "refractive"
                    ? _c("refractiveReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "bmdReport"
                    ? _c("bmdReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "drReport"
                    ? _c("drReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                  item.code === "lisReport"
                    ? _c("lisReport", {
                        attrs: {
                          physicalId: _vm.physicalId,
                          barCode: _vm.barCode,
                          reportCode: _vm.reportCode,
                          printData: _vm.printData,
                        },
                        on: { "on-setReportData": _vm.onSetReportData },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e()
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }